<template>
  <div class="solution1">
    <div class="x-top">
      <guide :guide="guide"></guide>
    </div>
    <div class="x-container">
      <div class="news-container">
        <div class="news-detail-container" style="text-align: left;" v-html="content"></div>
      </div>
      <div style="text-align: center">
        <!--<span class="x-btn" @click="goBack">返回</span>-->
      </div>
    </div>
  </div>
</template>

<script>
  import guide from '@/components/guide'
  import {selectSolutionById} from '@/api/solution'
  import {addIpPrefixToImageSrc} from "../../../utils/elTipTapFunction";
  export default {
    name: "solutionDtl",
    components: {
      guide,
    },
    data() {
      return {
        guide: [
          {label: '解决方案'},
        ],
        content:''
      }
    },
    methods: {
      // 获取解决方案详情页面信息
      getSolutionDtlById(id){
        selectSolutionById({
          id: id
        }).then(res=>{
          if(res.returnCode==='100'){
            this.content = addIpPrefixToImageSrc(res.returnData.content, this.$commonPicUrl);
            // 上方导航内容
            this.guide = [
              {label: '解决方案'},
              {label: res.returnData.columnName}
            ]
          }
        })
      },
      goBack(){
        this.$router.back();
      }
    },
    // 从其它页面进入触发的是enter
    beforeRouteEnter(to, from, next){
      next(vm=>{
        vm.getSolutionDtlById(to.params.id);
      })
    },
    // 同样的页面仅是路由切换则是触发update
    beforeRouteUpdate (to, from, next) {
      this.getSolutionDtlById(to.params.id)
      next()
    }
  }
</script>

<style scoped lang="less">
  .x-top {
    min-height: 23rem;
    .x-top-img {
      text-align: right;
      img {
        width: 20rem;
      }
    }
  }

  .x-container {
    /*新闻列表*/
    .news-container {
      margin: auto;
      margin-bottom: 3rem;
      padding: 1rem;
      min-height: 30rem;
      background: transparent;
      /*box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);*/
      /*border-radius: 15px;*/
      .title {
        font-size: 1.1rem;
        padding: 1rem;
        color: @deepblue;
      }
      .img{
        width: 100%;
        margin-bottom: 20px;
      }
    }
    .x-btn {
      text-align: center;
      display: inline-block;
      color: #fff;
      background-image: linear-gradient(to right, rgb(112, 68, 249), rgb(84, 106, 238));
      width: 4rem;
      border-radius: 50px;
      padding: 0.5rem 2rem 0.5rem 2rem;
      cursor: pointer;
    }
  }
</style>
<style lang="less" scoped>
  @media only screen and (min-width: 320px) {
    .x-top {
      background: url("../../../assets/img/mobile/about/about3/background.png") !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center center !important;
      box-sizing: border-box !important;
    }

  }

  @media only screen and (min-width: 768px) {
    .x-top {
      background: url("../../../assets/img/pc/about/about3/background.png") !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center center !important;
      box-sizing: border-box !important;
    }
    .x-container {
      /*新闻列表*/
      .news-container {
        width: 80%;
        .img{
          width: 80%;
        }
      }
    }
  }
</style>
<style>
  .news-detail-container img{
    max-width: 100%;
  }
</style>
